import { Injectable } from '@jkhy/frontend-utils/di';
import { JhHttpClient } from '@jkhy/frontend-utils/http';

/**
 * HTTP Client that wraps a `fetch()` implementation
 * to include Treasury Management-specific headers and behavior.
 */
@Injectable()
export class TmBffHttpClient extends JhHttpClient {
    constructor() {
        super(window.fetch.bind(window), {
            baseUrl: '/bff/nag',
        });
    }
}
